import styled from "styled-components";

const CardList = styled.div`
  border-radius: 12px;
  background-color: rgba(42, 46, 67, 0.1);
  padding: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export { CardList };
